import { render, staticRenderFns } from "./Promotions.vue?vue&type=template&id=75ae17b2&scoped=true"
import script from "./Promotions.vue?vue&type=script&lang=js"
export * from "./Promotions.vue?vue&type=script&lang=js"
import style0 from "./Promotions.vue?vue&type=style&index=0&id=75ae17b2&prod&lang=scss&scoped=true"
import style1 from "./Promotions.vue?vue&type=style&index=1&id=75ae17b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ae17b2",
  null
  
)

export default component.exports